// logic for the dynamic quote popup

export function closePopup(wrapper, modal, toggle, banner) {
  // close wrapper
  wrapper.classList.add("wrapper-closed");

  // after animation, remove classes
  setTimeout(() => {
    wrapper.classList.remove("wrapper-closed");
    wrapper.classList.remove("wrapper-open");
  }, 1000);

  // close modal
  modal.classList.remove("modal-open");
  modal.classList.add("modal-closed");

  // after animation, hide modal
  setTimeout(() => {
    // update banner z-index
    banner.classList.remove("z-20");
    banner.classList.add("z-50");
    // hide modal
    modal.classList.add("hidden");
  }, 1000);

  // call toggle animation
  toggleAnimation(toggle);
}

export function openPopup(wrapper, modal, banner) {
  // before animation update header z-index
  banner.classList.remove("z-50");
  banner.classList.add("z-20");

  // open wrapper and add opening animation
  wrapper.classList.add("wrapper-open");

  // open modal
  // remove initial classes and add opening animation
  modal.classList.remove("modal-closed");
  modal.classList.remove("hidden");
  modal.classList.add("modal-open");
}

// function to call the animation for the quote form toggle
export function toggleAnimation(toggle) {
  // hide toggle for animations
  toggle.classList.remove("toggle-open");
  toggle.classList.add("hidden");

  // after animation modal animation has finished, fade back in. This is to prevent the toggle from being visible during the modal animation
  setTimeout(() => {
    toggle.classList.add("toggle-open");
    toggle.classList.remove("hidden");
  }, 500);
}

// function to handle click outside of modal
export function listener(e) {
  // need to reselect elements as we need the updated DOM from e
  const modal = document.querySelector(".quote-form-modal");
  const toggle = document.querySelector(".quote-form-toggle");
  const wrapper = document.querySelector(".quote-form-toggle-wrapper");
  const banner = document.querySelector(".banner");

  if (
    !modal.contains(e.target) &&
    !toggle.contains(e.target) &&
    modal.classList.contains("modal-open")
  ) {
    console.log("clicked outside");
    closePopup(wrapper, modal, toggle, banner);
    document.removeEventListener("click", listener);
  }
}



// WEBPACK FOOTER //
// ./scripts/routes/quotePopup.js